import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import userStore from './mobx-stores/userStore';
import adminStore from './mobx-stores/adminStore';
import constants from './constants';
import dashboardStore from './mobx-stores/dashboardStore';


const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = constants.API_ROOT;
const SNIPPET_API_ROOT = constants.SNIPPET_API_ROOT;
const SERVER_ROOT = constants.SERVER_ROOT;

const encode = encodeURIComponent;

const handleErrors = (err, res) => {
  if (err && err.response && err.response.status === 401) {
    userStore.goToLogin();
  }
  return err;
};

const errorHandler = (err, res) => {
  if (err && err.response && err.response.status === 401) {
    userStore.goToLogin();
  }
  let error = {
    error: err,
    response: res
  }
  return error;
};

const responseBody = res => res.body;
const responseText = res => res.text;
const responseFull = res => res;

const tokenPlugin = req => {
  if (userStore.token) {
    req.set('Authorization', `Bearer ${userStore.token}`);
  }
};


const serverToken = req => {
  if (userStore.token) {
    req.set('Authorization', `Bearer 104f03dc1fb835b8d0fa668f18a8a674`);
  }
};


const requestsReports = {
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
};

const requests = {
  del: (url, body) =>
    superagent
      .del(`${API_ROOT}${url}`)
      .send(body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  getFull: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseFull),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  postAttachments: (url, files, assignTo, comment, documentCategory) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('files', files[0])
      .attach('files', files[1])
      .attach('files', files[2])
      .attach('files', files[3])
      .attach('files', files[4])
      .attach('files', files[5])
      .attach('files', files[6])
      .attach('files', files[7])
      .attach('files', files[8])
      .attach('files', files[9])
      .attach('files', files[10])
      .field('assignTo', assignTo)
      .field('comment', comment)
      .field('documentCategory', documentCategory)
      .end(handleErrors)
      .then(responseBody),
  uploadProfilePic: (url, file) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('file', file)
      .end(handleErrors)
      .then(responseBody),
  postAttachmentsWithoutCom: (url, files, assignTo, documentCategory) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('files', files[0])
      .attach('files', files[1])
      .attach('files', files[2])
      .attach('files', files[3])
      .attach('files', files[4])
      .attach('files', files[5])
      .attach('files', files[6])
      .attach('files', files[7])
      .attach('files', files[8])
      .attach('files', files[9])
      .attach('files', files[10])
      .field('assignTo', assignTo)
      .field('documentCategory', documentCategory)
      .end(handleErrors)
      .then(responseBody),
  postAttachment: (url, files, templateName) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('files', files)
      .field('templateName', templateName)
      .end(handleErrors)
      .then(responseBody),
  postAgent: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(errorHandler)
      .then(responseBody),
  getSnippet: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseText),
};

const uploadRequests = {
  get: url =>
    superagent
      .get(`${SNIPPET_API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseText)
};

const serverRequests = {
  get: url =>
    superagent
      .get(`${SERVER_ROOT}${url}`)
      .use(serverToken)
      .end(handleErrors)
      .then(responseText)
};

const Upload = {
  snippet: (imageURL, coordinates) =>
    uploadRequests.get(`?s3_url=${imageURL}&x1=${coordinates.x1}&y1=${coordinates.y1}&x2=${coordinates.x2}&y2=${coordinates.y2}`)
};

const Server = {
  getServerStatus: () =>
    serverRequests.get(`/aiStatus/vision`)
};

const agentsRequest = {
  postCsv: (url, csv_file) =>
    superagent
      .post(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .accept('application/json')
      .attach('csv_file', csv_file)
      .end(handleErrors)
      .then(responseBody),
  get: url =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
  del: (url, body) =>
    superagent
      .del(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .end(handleErrors)
      .then(responseBody),
}


const Auth = {
  login: (email, password) =>
    requests.post('/user/login', { email, password }),
  logout: () =>
    requests.post('/user/logout'),
  register: (newUser) =>
    requests.post('/user/register', newUser),
  verifyEmail: (token) =>
    requests.get(`/user/verify_email?token=${token}`),
  verifyUpdatedEmail: (token) =>
    requests.get(`/user/verifyUpdatedEmail?token=${token}`),

  searchUser: (enterpriseId, name) =>
    requests.get(`/users/?enterpriseId=${enterpriseId}&name=${name}`),
  getAllUsers: (enterpriseId, type, forMapping) =>
    requests.get(`/users/?enterpriseId=${enterpriseId}&type=${type}&forMapping=${forMapping}`),
  filterUsers: (filterDetails) =>
    requests.post('/users/searchUser', filterDetails),
  requestPasswordReset: (email) =>
    requests.post('/user/forgotPassword', { email: email }),
  verifyPasswordToken: (token) =>
    requests.postAgent('/users/verifyPasswordToken', { token: token }),
  resetPassword: (token, password) =>
    requests.put('/user/resetPassword', { token: decodeURIComponent(token), password: password }),
  updateEmailResetPassword: (token, password) =>
    requests.put('/user/updateEmailResetPassword', { token: decodeURIComponent(token), password: password }),
};

const Dashboard = {
  uploadFiles: (files, assignTo, comment, documentCategory) => {
    if (comment.length > 0)
      return requests.postAttachments(`/upload/mixedFiles`, files, assignTo, comment, documentCategory)
    else
      return requests.postAttachmentsWithoutCom(`/upload/mixedFiles`, files, assignTo, documentCategory)
  },
  getFilteredDocuments: (filter, sortField, sortDirection, searchQuery) => {
    if (searchQuery === undefined)
      return requests.get(`/upload/getDocumentList?pageNo=${dashboardStore.pageNo}&docStatus=${filter}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/upload/getDocumentList?pageNo=${dashboardStore.pageNo}&docStatus=${filter}&sortField=${sortField}&sortDirection=${sortDirection}&searchQuery=${searchQuery}`)
  },
  getHomePageData: (sortField, sortDirection, searchQuery) => {
    if (searchQuery === undefined)
      return requests.get(`/user/getHomePageData?pageNo=${dashboardStore.pageNo}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/user/getHomePageData?pageNo=${dashboardStore.pageNo}&sortField=${sortField}&sortDirection=${sortDirection}&searchQuery=${searchQuery}`)

  },

  getDocumentDetails: (documentId) =>
    requests.get(`/upload/getDocumentDetails?documentId=${documentId}`)
}

const Documents = {
  deleteDocument: (documentId) => {
    return requests.del(`/upload/delete`, { documentId })
  },
  downloadDocument: (fileName) =>
    requests.get(`/upload/downloadFile?fileName=${fileName}`),
  updateDocument: (body) =>
    requests.put(`/upload/editDocumentFields`, body),
  updatePoSoDocument: (body) =>
    requests.put(`/upload/editPoDocumentFields`, body),
  updateMediassistDocument: (body) =>
    requests.put(`/upload/editMediassistDocumentFields`, body),
  updateWritercorpDocument: (body) =>
    requests.put(`/upload/editWritercorpDocumentFields`, body),
  getDownloadTokenForDoc: (documentId) =>
    requests.post(`/upload/createDownloadTokenForDoc`, { documentId }),
  getDownloadTokenForXls: (documentId) =>
    requests.post(`/upload/exportXls`, { documentId }),
  downloadOriginalDoc: (documentId, downloadToken) =>
    requests.get(`/upload/downloadOriginalDoc?downloadToken=${downloadToken}&documentId=${documentId}`),
  searchDocuments: (keyword, docStatus) =>
    requests.get(`/upload/search?keyword=${keyword}&docStatus=${docStatus}`),
  getSnippetTextPo: (imageUrl, coordinates) =>
    requests.getSnippet(`/upload/getPoSnippetText?imageUrl=${imageUrl}&x1=${coordinates.x1}&y1=${coordinates.y1}&x2=${coordinates.x2}&y2=${coordinates.y2}`),
}

const Admin = {
  createUser: (user) =>
    requests.post(`/user/createViaAdmin`, user),
  editUser: (user) =>
    requests.put(`/user/updateUserByAdmin`, user),
  createEnterprise: (enterprise) =>
    requests.post(`/enterprise/create`, enterprise),
  deleteUser: (userId) =>
    requests.del(`/user/deleteUser`, { userId }),
  searchUsers: (keyword) =>
    requests.get(`/user/searchUsers?keyword=${keyword}`),
  getUserList: (assignFlag, sortField, sortDirection, nameFilter) => {
    if (nameFilter === undefined)
      return requests.get(`/user/getList?pageNo=${adminStore.pageNo}&assignFlag=${assignFlag}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/user/getList?pageNo=${adminStore.pageNo}&assignFlag=${assignFlag}&sortField=${sortField}&sortDirection=${sortDirection}&nameFilter=${nameFilter}`)
  },
  changePassword: (userId, newPassword) =>
    requests.put('/user/changePasswordByAdmin', { userId, newPassword }),
  resendUpdateVerificationEmail: (email) =>
    requests.post(`/user/resendUpdateVerificationEmail`, { email })

}

const User = {
  assignDocuments: (documentsIdArray, assignTo) =>
    requests.post(`/user/assignDocument`, { documentsIdArray, assignTo }),
  getUserDetails: (userId) =>
    requests.get(`/user/getUserDetails`),
  changePassword: (oldPassword, newPassword) =>
    requests.put('/user/changePassword', { oldPassword, newPassword }),
  getUserList: (assignFlag, sortField, sortDirection) => {
    return requests.get(`/user/getList?assignFlag=${assignFlag}`)
  },
  updateUserSettings: (user) =>
    requests.put(`/user/updateUserSelf`, user),
  uploadProfilePicture: (img) =>
    requests.uploadProfilePic(`/user/uploadProfilePic`, img)
}

const Stats = {
  getStatusReport: (startDate, endDate) =>
    requests.get(`/stats/statusReport?startDate=${startDate}&endDate=${endDate}`),
  getDownloadTokenForStats: () =>
    requests.get(`/stats/getDownloadTokenForStats?enterpriseId=5e83501c53444f6c91bf1ffc`),
}

const Template = {
  getTemplateList: () =>
    requests.get(`/template/getGlobalList?limit=17&pageNo=0`),
  getTemplateDetails: (templateId) =>
    requests.get(`/template/getLocalTemplateDetails?templateId=${templateId}`),
  uploadTemplate: (file, templateName) =>
    requests.postAttachment(`/template/uploadTemplate`, file, templateName),
  deleteTemplate: (templateId) =>
    requests.del(`/template/deleteGlobalTemplate`, { templateId }),
  updateTemplate: (body) =>
    requests.put(`/template/updateLocalTemplate`, body),
  getOutputMapping: (templateId) =>
    requests.get(`/template/getOutputMapping?localTemplateId=${templateId}`),
  saveOutputMapping: (templateId, outputMapping) =>
    requests.put(`/template/saveLocalOutputMapping`, { templateId, outputMapping }),
  updateExportType: (templateId, exportOutputFormat) =>
    requests.put(`/template/updateOutputMappingSaveFormat`, { templateId, exportOutputFormat })
}

const SuperAdmin = {
  getGlobalDocumentList: (filter, sortField, sortDirection, searchQuery) => {
    if (searchQuery === undefined)
      return requests.get(`/superAdmin/getDocumentList?pageNo=${dashboardStore.pageNo}&docStatus=${filter}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/superAdmin/getDocumentList?pageNo=${dashboardStore.pageNo}&docStatus=${filter}&sortField=${sortField}&sortDirection=${sortDirection}&searchQuery=${searchQuery}`)
  },
  getGlobalUserList: (assignFlag, sortField, sortDirection, nameFilter) => {
    if (nameFilter === undefined)
      return requests.get(`/superAdmin/getUsersList?pageNo=${adminStore.pageNo}&assignFlag=${assignFlag}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/superAdmin/getUsersList?pageNo=${adminStore.pageNo}&assignFlag=${assignFlag}&sortField=${sortField}&sortDirection=${sortDirection}&nameFilter=${nameFilter}`)
  },
  blockIP: (ip) =>
    requests.post(`/ip/block`, { ip }),
  unblockIP: (ip) =>
    requests.post(`/ip/unblock`, { ip }),
  blockDomain: (domain) =>
    requests.post(`/ip/blockDomain`, { domain }),
  unblockDomain: (domain) =>
    requests.post(`/ip/unblockDomain`, { domain }),
  getBlockedList: (blockCategory, sortField, sortDirection, searchQuery) => {
    if (searchQuery === undefined)
      return requests.get(`/ip/getBlockList?pageNo=${adminStore.pageNo}&blockCategory=${blockCategory}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/ip/getBlockList?pageNo=${adminStore.pageNo}&blockCategory=${blockCategory}&sortField=${sortField}&sortDirection=${sortDirection}&searchFilter=${searchQuery}`)

  },
  getEnterpriseList: (sortField, sortDirection, nameFilter) => {
    if (nameFilter === undefined)
      return requests.get(`/enterprise/getList?pageNo=${adminStore.pageNo}&sortField=${sortField}&sortDirection=${sortDirection}`)
    else
      return requests.get(`/enterprise/getList?pageNo=${adminStore.pageNo}&sortField=${sortField}&sortDirection=${sortDirection}&nameFilter=${nameFilter}`)
  }

}

export default {
  Auth,
  Admin,
  Upload,
  Dashboard,
  Documents,
  User,
  Stats,
  Template,
  SuperAdmin,
  Server
};
